import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { SectorActividad } from 'app/main/models/sector-actividad.model';


@Component({
  selector: 'sector-actividad-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class SectorActividadDialogBoxComponent {

  action: string;
  LOCAL_DATA: any;

  roles = [];
  empresas = [];

  constructor(
    public dialogRef: MatDialogRef<SectorActividadDialogBoxComponent>,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: SectorActividad) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.action = this.LOCAL_DATA.action;
  }

  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {
  }

}
